module.exports = __webpack_public_path__ + "static/img/purchase-tips-2.b70d466b.png";